<template>
  <div id="pdf" class="pdf">
    <button
      :style="{ visibility: pageNum > 1 ? 'visible' : 'hidden' }"
      @click="pageNum--"
    >
      <md-icon>navigate_before</md-icon>
    </button>
    <input
      v-model.number="pageNum"
      @input="renderPage"
      size="4"
      :min="1"
      :max="numPages"
    />
    / {{ numPages }}
    <span v-if="outOfRange" style="color: red">out of range!</span>
    <button v-show="pageNum < numPages" @click="pageNum++">
      <md-icon>navigate_next</md-icon>
    </button>
    <button
      @click="width = width === '60%' ? '100%' : '60%'"
      style="margin-left: 20px;"
    >
      <md-icon>expand</md-icon>
    </button>
    <input v-model="viewQuery" @keydown.enter="searchView" />
    {{ viewQuery }}
    <br />
    <div ref="container" id="pdf-container" class="pdfViewer  singlePageView">
      <canvas id="the-canvas" class="viewer"></canvas>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import pdfjsLib from 'pdfjs-dist'
import 'pdfjs-dist/web/pdf_viewer.css'
import {
  DefaultAnnotationLayerFactory,
  DefaultTextLayerFactory,
  PDFLinkService,
  PDFPageView,
  PDFViewer,
  PDFSinglePageViewer,
  PDFFindController,
} from 'pdfjs-dist/web/pdf_viewer.js'

export default {
  name: 'PDF',

  props: ['loading', 'docView'],

  data() {
    return {
      pdfDoc: null,
      pdfViewer: null,
      numPages: null,
      pageNum: 1,
      scale: 1,
      rotate: 0,
      canvas: null,
      context: null,
      outOfRange: false,
      viewQuery: '',
    }
  },

  methods: {
    ...mapActions({
      notify: 'util/notify',
    }),

    searchView() {
      this.pdfFindController.executeCommand('find', {
        caseSensitive: false,
        findPrevious: undefined,
        highlightAll: true,
        phraseSearch: true,
        query: this.viewQuery,
        setCurrentPage: true,
      })
      // this.pdfViewer.eventBus.on('updatefindmatchescount', data => {
      // this.searchMatchesLength = data.matchesCount.total;
      // });
      console.log(this.page)
      console.log(this.pdfFindController._pageMatches)
    },

    renderPage: async function() {
      if (this.pageNum < 1 || this.pageNum > this.numPages) {
        this.outOfRange = true
        return
      } else {
        this.outOfRange = false
      }
      setTimeout(() => {
        const p = document.getElementById('page' + this.pageNum)
        if (!p) return
        p.scrollIntoView()
      }, 10)
    },

    async renderPDF() {
      this.pdfDoc = await pdfjsLib.getDocument({ data: this.docView.bytes })
      this.numPages = this.pdfDoc.numPages
      this.page = await this.pdfDoc.getPage(this.pageNum)
      this.pdfLinkService = new PDFLinkService()
      this.pdfFindController = new PDFFindController({
        linkService: this.pdfLinkService,
      })
      this.canvas = document.getElementById('the-canvas')
      this.context = this.canvas.getContext('2d')
      let viewport = this.page.getViewport(this.scale)
      this.canvas.height = viewport.height
      this.canvas.width = viewport.width

      await this.page.render({
        canvasContext: this.context,
        viewport,
        textLayerFactory: new DefaultTextLayerFactory(),
        linkService: this.pdfLinkService,
        findController: this.pdfFindController,
      })
    },
  },

  watch: {
    loading: {
      handler: async function(val) {
        if (val) return
        await this.renderPDF()
      },
      immediate: true,
    },

    async pageNum(val) {
      await this.renderPDF()
    },
  },
}
</script>

<style scoped>
#pdf-container {
  border: solid 1px #444;
  overflow-y: scroll;
}
.pdf {
  margin: 4px;
  padding: 4px;
  border: solid 1px #9b9;
}
</style>
